import type { TotalActionsRowItem } from '@/app/types/Dashboard';
import type { PointOptionsObject } from 'highcharts';

const defaultOptions = {
	credits: {
		enabled: false,
	},
	chart: {
		type: 'pie',
		plotBackgroundColor: undefined,
		plotBorderWidth: 0,
		plotShadow: false,
		margin: 0,

		borderRadius: 0,
		height: 226,
		width: 226,

		style: {
			margin: '0px',
			padding: '0px',
		},
	},
	xAxis: {
		maxPadding: 0,
		minPadding: 0,
		min: 0,
		max: 0,
		gridLineWidth: 0,
	},
	yAxis: {
		maxPadding: 0,
		minPadding: 0,
		gridLineWidth: 0,
	},
	title: {
		text: '',
	},

	accessibility: {
		point: {
			valueSuffix: '%',
		},
		enabled: false,
	},
	legend: {
		enabled: false,
		borderWidth: 0,
		margin: 0,
	},
	tooltip: {
		enabled: true,
		headerFormat: '',
		pointFormatter: function (this: Highcharts.Point) {
			return `
				<p style="min-width: 200px; max-width: 350px; white-space: nowrap;">
					<p class="tooltip-header"><span style="color:${this.color as string}">\u25CF</span>
				<p>${this.name} ${this.y}%</p>
				</p>
			`;
		},
	},
	plotOptions: {
		pie: {
			borderWidth: 0,
			size: 226,
			innerSize: '0%',
			scale: 1,
			margin: 0,
			padding: 0,
			center: ['50%', '50%'],
			dataLabels: {
				enabled: true,
				distance: 0,
				style: {
					fontWeight: 'bold',
					color: 'transparent',
					opacity: 0,
					backgroundColor: 'transparent',
					margin: 0,
					padding: 0,
					textOutline: 'none',
				},
			},
			enableMouseTracking: true,
		},
		series: {
			states: {
				inactive: { enabled: false },
				hover: {
					enabled: false,
					halo: null, // no outer halo ring
				},
			},
		},
	},
};

export const Chart = {
	toTotalActionsOptions: (itemData: TotalActionsRowItem[]) => {
		const sortedItems = [...(itemData ?? [])].sort((a, b) => b.total - a.total);
		const data: PointOptionsObject[] = sortedItems.map((item) => {
			return {
				y: Number(item.total.toFixed()),
				name: item.triggerName,
				color: item.triggerColor,
				custom: item,
			};
		});

		return {
			...defaultOptions,
			series: [
				{
					data,
				},
			],
		};
	},
};
